import BenchlingConfig from 'BenchlingConfig';
import {COLUMN_TYPE, IMPORT_TYPE, SpreadsheetColumn} from 'bulk-import/SpreadsheetBulkImportConstants';
import * as SpreadsheetBulkImportUtil from 'bulk-import/SpreadsheetBulkImportUtil';
import {SampleControlsFeatureLevel} from 'inventory/sample-status/SampleControlsFeatureLevel';
import {hasMinimumSCRFeatureLevel} from 'inventory/sample-status/SampleControlsFeatureLevelUtil';

export function getRequiredParentStorableError(columns: Array<SpreadsheetColumn>): string | null {
  if (!BenchlingConfig.ENABLE_REQUIRED_PARENT_STORABLE) {
    return null;
  }
  return SpreadsheetBulkImportUtil.getRequiredFieldError(
    [COLUMN_TYPE.PARENT_STORABLE_BARCODE],
    columns,
    {},
    IMPORT_TYPE.UPDATE_CONTAINERS
  );
}

export function getSampleControlRolesColumns(): Array<COLUMN_TYPE> {
  if (hasMinimumSCRFeatureLevel(SampleControlsFeatureLevel.V2)) {
    return [
      COLUMN_TYPE.SAMPLE_RESTRICTION_STATUS,
      COLUMN_TYPE.SAMPLE_AUTHORIZED_USERS,
      COLUMN_TYPE.SAMPLE_OWNERS,
    ];
  } else {
    return [];
  }
}

export function getLocationCapacityConfigColumns(): Array<COLUMN_TYPE> {
  return [
    COLUMN_TYPE.ALLOWS_NON_LOCATION_CHILDREN,
    COLUMN_TYPE.LOCATION_CAPACITY,
    COLUMN_TYPE.ALLOWED_CHILD_STORABLE_SCHEMAS,
  ];
}

export function getValidContentsContainerColumns(): Array<COLUMN_TYPE> {
  return [
    ...(BenchlingConfig.INVENTORY_ENABLE_EXPIRATION_DATE ? [COLUMN_TYPE.EXPIRATION_DATE_OVERRIDE] : []),
    ...(BenchlingConfig.INVENTORY_ENABLE_FREEZE_THAW ? [COLUMN_TYPE.FREEZE_THAW_COUNT] : []),
  ];
}
